import { Bell } from 'lucide-react';
import { BrandMark } from '../../../components/ui/bits';

/** A faithful-enough mock of the iOS notification banner for the composer. */
export function NotificationPreview({ title, body, cta }: { title: string; body: string; cta: string | null }) {
  return (
    <div className="rounded-[20px] bg-gradient-to-br from-[#1C1C24] to-[#0C0C10] p-[15px] shadow-card">
      <div className="flex items-start gap-[13px]">
        <div className="grid h-[42px] w-[42px] shrink-0 place-items-center rounded-tile bg-accent-wash text-accent-ink">
          <Bell size={22} strokeWidth={2.2} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="truncate text-[14px] font-bold tracking-snug text-white">
            {title.trim() || 'Notification title'}
          </div>
          <div className="mt-[2px] line-clamp-3 text-[12px] font-medium leading-[1.4] text-[#9A9AA4]">
            {body.trim() || 'Your message shows up here. Keep it short and punchy.'}
          </div>
        </div>
      </div>
      {cta && (
        <div className="mt-[13px] flex items-center justify-center rounded-tile bg-white/10 py-[11px]">
          <span className="text-[13px] font-extrabold tracking-snug text-white">{cta}</span>
        </div>
      )}
      <div className="mt-3 flex items-center gap-1.5 px-1 text-[10px] font-semibold uppercase tracking-eyebrow text-[#7E7E88]">
        <BrandMark size={12} /> HeadToHead · in-app + push
      </div>
    </div>
  );
}
